import { Typography } from 'antd'
import { getRatingGuideData } from './ratingScale'

const { Text } = Typography

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: 8,
  fontSize: 16,
  lineHeight: 1.5
}

const headerStyle = {
  padding: '10px 12px',
  border: '1px solid #d9d9d9',
  background: 'var(--neutral-grey0)',
  textAlign: 'left',
  fontWeight: 700,
  lineHeight: 1.5
}

const cellStyle = {
  padding: '10px 12px',
  border: '1px solid #d9d9d9',
  verticalAlign: 'top',
  whiteSpace: 'pre-line',
  lineHeight: 1.5
}

export default function RatingGuideTable ({ source }) {
  const { conversionGuide, descriptions } = getRatingGuideData(source)
  const configuredGuide = source?.rating_scale_guide || source?.form_config?.rating_scale_guide || {}
  const headers = configuredGuide.headers || {}
  const showConversionTable = configuredGuide.show_conversion_table !== false
  const showDescriptionTitle = configuredGuide.show_description_title !== false
  const showPerformanceStandards = descriptions.some(item => Object.prototype.hasOwnProperty.call(item, 'performance_standards'))

  return (
    <div className='tti-rating-guide' style={{ overflowX: 'auto' }}>
      {showConversionTable && (
        <>
          <Text strong className='tti-rating-guide-heading'>Performance Rating Conversion</Text>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={{ ...headerStyle, width: '15%' }}>Code</th>
                <th style={{ ...headerStyle, width: '25%' }}>Range</th>
                <th style={headerStyle}>Rating</th>
              </tr>
            </thead>
            <tbody>
              {conversionGuide.map(item => (
                <tr key={item.code}>
                  <td style={cellStyle}><strong>{item.code}</strong></td>
                  <td style={cellStyle}>{item.range}</td>
                  <td style={cellStyle}>{item.rating}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <div style={{ marginTop: showConversionTable ? 20 : 0 }}>
        {showDescriptionTitle && (
          <Text strong className='tti-rating-guide-heading'>Performance Rating Description</Text>
        )}
        <table style={tableStyle}>
          <thead>
            <tr>
              {showPerformanceStandards
                ? (
                  <>
                    <th style={{ ...headerStyle, width: '24%', whiteSpace: 'pre-line' }}>{headers.rating || 'Rating'}</th>
                    <th style={{ ...headerStyle, width: '32%', whiteSpace: 'pre-line' }}>{headers.definition || 'Definition'}</th>
                    <th style={{ ...headerStyle, whiteSpace: 'pre-line' }}>{headers.performance_standards || 'Performance Standards'}</th>
                  </>
                  )
                : (
                  <>
                    <th style={{ ...headerStyle, width: '12%' }}>Code</th>
                    <th style={{ ...headerStyle, width: '24%' }}>Rating</th>
                    <th style={headerStyle}>Description</th>
                  </>
                  )}
            </tr>
          </thead>
          <tbody>
            {descriptions.map(item => {
              const standards = item.performance_standards
              const hasStandards = standards !== undefined && standards !== null && String(standards).trim() !== ''
              return (
                <tr key={item.code}>
                  {showPerformanceStandards
                    ? (
                      <>
                        <td style={cellStyle}>{item.rating}{item.code ? ` (${item.code})` : ''}</td>
                        {/* When a row has no performance standards (e.g. New in
                            Position), let the definition span the full width. */}
                        <td style={cellStyle} colSpan={hasStandards ? 1 : 2}>{item.description}</td>
                        {hasStandards && <td style={cellStyle}>{standards}</td>}
                      </>
                      )
                    : (
                      <>
                        <td style={cellStyle}><strong>{item.code}</strong></td>
                        <td style={cellStyle}>{item.rating}</td>
                        <td style={cellStyle}>{item.description}</td>
                      </>
                      )}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
